import type { EditorState } from "../vim/model/editor-state";

/**
 * 演習試行の手数を取り出す。vimエンジンが管理する `EditorState.usedKeystrokes` を
 * そのまま用いる（ADR-011: vimの入力単位を1打とし、未習得キー・修飾キー単独押下は
 * 0打として `reduce()` 自身が計上する）。Learning はこのカウントの計算方法を持たない。
 */
export function keystrokesUsed(state: EditorState): number {
  return state.usedKeystrokes;
}
